import { defineMessages } from '@cookbook/solid-intl'

// Split out of `browser-extension-landing-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Add the Lodgr browser extension to see price history, flexible-date savings, and better deals while browsing Airbnb and VRBO.',
        id: 'BrowserExtensionLandingPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Browser Extension | Lodgr',
        id: 'BrowserExtensionLandingPage.titleMessage',
    }),
}
